<div class="drafts">
    <div class="drafts__header">
        <h2 class="drafts__title">My Drafts</h2>
        <button (click)="closeModal.emit()">
            <svg width="18" height="18">
                <use [attr.xlink:href]="'assets/icons/icons-sprite.svg#close'"></use>
            </svg>
        </button>
    </div>

    @if (drafts().length > 0) {
        <div class="drafts__list">
            @for (draft of drafts(); track draft.id) {
                <div class="draft-card" role="button" tabindex="0" (click)="selectDraft(draft.id)">
                    <div class="draft-card__header">
                        <div>
                            <h3 class="draft-card__title">
                                {{ 'Create ' + splitCamelCase(draft.role) || 'New User Draft' }}
                                @if (draft.id) {
                                    <span class="draft-card__id"
                                        >- {{ draft.id.substring(0, 4) }}</span
                                    >
                                    @if (
                                        currentSelectedDraftId() &&
                                        draft.id === currentSelectedDraftId()
                                    ) {
                                        <span class="draft-card__current">current</span>
                                    }
                                }
                            </h3>
                        </div>
                        <div class="draft-card__action">
                            <app-button
                                (buttonClick)="deleteDraft(draft.id)"
                                variant="danger"
                                iconKey="delete"
                                [iconSize]="{ width: 14, height: 14 }"
                                class="delete-btn" />
                        </div>
                    </div>
                    <div class="draft-card__body">
                        <div class="draft-card__meta">
                            <p class="draft-card__meta-item">
                                <span class="draft-card__label">Created at:</span>
                                {{ draft.createdAt | date: 'MMMM d, y, h:mm a' }}
                            </p>
                            <p class="draft-card__meta-item">
                                <span class="draft-card__label">Updated at:</span>
                                {{ draft.updatedAt || draft.createdAt | date: 'MMMM d, y, h:mm a' }}
                            </p>
                        </div>
                    </div>
                </div>
            }
        </div>
    } @else {
        <div class="drafts__empty">
            <p>No drafts found. Your progress will be saved automatically as you fill out forms.</p>
        </div>
    }
</div>
